module.exports = __webpack_public_path__ + "static/media/space_incomplete.c7d79f17.svg";